import React from "react";
import {Select} from "antd";
import {get, postSync} from "../../utils/http";
import {isEmpty} from "../../utils/StringUtils";
import {getLanguage} from "../../../source/js/common";

const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common');

const Option = Select.Option;

class CommonUrlSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oriData:[],
            optionsData: '',
            url:props.url,
            param:props.param,
            type:props.type,
            selected:"",
        };
    }
    loadSelectData(url,param,type){
        const that=this;
        that.state.url=url;
        that.state.param=param;
        that.state.type=type;
        that.requestData();
    }
    getData(){
        return this.state.oriData;
    }
    getSelected(selected){
        if(!selected){
            return {};
        }
        let oriData =this.state.oriData;
        let valueField=this.props.valueField;
        if(!isEmpty(selected)&&oriData){
            for(let i=0;i<oriData.length;i++){
                if(oriData[i][valueField] ===selected)
                return oriData[i];
            }
        }
    }
    componentDidMount(){
        const that=this;
        if(!isEmpty(this.state.url)){
            that.requestData();
        }
    }
    setSelectData(data){
        if(data){
            this.state.oriData=data;
            let children = [];
            if(this.props.source==="search"){
                children.push(<Option key={"All"} value={""}>{commonLan.all.label}</Option>);
            }
            for (let i = 0; i < data.length; i++) {
                children.push(<Option key={data[i][this.props.textField]+i} value={data[i][this.props.valueField]}>{data[i][this.props.textField]}</Option>);
            }
            this.setState({optionsData:children});
        }
    }
    requestData(){
        const that=this;
        let request ;
        let requestType=that.state.type;
        if(requestType==='post'){
            request = that.requestPostOption();
        }else{
            request = that.requestGetOption();
        }
        request.then(response => {
            if (response) {
                that.setSelectData(response);
            }
        });
    }
    requestGetOption(){
        return get(this.state.url,this.state.param);
    }
    requestPostOption(){
        return postSync(this.state.url,this.state.param);
    }
    componentWillUnmount() {
        this.setState = ()=>false;
    }
    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):""
        return (
            <div className={styleBg?"selectBg":""}>
               <Select
                    labelInValue={this.props.labelInValue}
                    style={{...this.props.style,background:styleBg?"#ffffe6":""}}
                    allowClear = {this.props.allowClear}
                    showSearch
                    onChange={this.props.onChange}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    optionFilterProp="children"
                    placeholder={commonLan.pleaseSelect.label}
                    defaultValue={this.props.defaultValue}
                >
                    {this.state.optionsData}
                </Select> 
            </div>
            
        );
    }
}
export default CommonUrlSelect;